import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SimpleSelectProps, SimpleSelect } from '@agro-club/frontend-shared'
import { ShirtSizes } from 'modules/domain/farmer/types'

const ShirtSizeSelect: React.FC<Omit<SimpleSelectProps, 'options'>> = ({ ...selectProps }) => {
  const { t } = useTranslation('farmer')
  const options = useMemo(() => {
    return Object.keys(ShirtSizes).map((e) => {
      return { id: ShirtSizes[e], title: t(`farmerShirtSizes.${ShirtSizes[e]}`) }
    })
  }, [t])

  return <SimpleSelect {...selectProps} options={options} isClearable />
}

export default ShirtSizeSelect
